exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.semichecked[data-v-fbd7e682] { \n    color:red!important;\n}\n.multiselect-td[data-v-fbd7e682] {\n    padding: 2px 10px;\n}\n.multiselect[data-v-fbd7e682] {\n    min-height: 28px;\n}\n.multiselect__tag[data-v-fbd7e682] {\n    display:block;\n}\n", ""]);

// exports
